import React from 'react';
import FeatherIcon from './FeatherIcon';

const Mission: React.FC = () => {
  return (
    <section id="mission" className="py-20">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold mb-4 text-gray-800">Our Mission</h2>
          <p className="text-xl max-w-3xl mx-auto text-gray-700">
            We provide free veterinary care to pets in underserved communities, working to reduce pet overpopulation through spay and neuter programs, decreasing the burden on shelters through direct, hands-on community action.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-10">
          <div className="card p-8 text-center">
            <div className="w-16 h-16 bg-primary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6">
              <FeatherIcon name="heart" className="text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-4 text-gray-800">Animal Healthcare</h3>
            <p className="text-gray-700">
              We provide free and low cost veterinary care to pets in underserved communities through a voucher program that removes cost as a barrier to treatment.
            </p>
          </div>
          <div className="card p-8 text-center">
            <div className="w-16 h-16 bg-secondary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6">
              <FeatherIcon name="users" className="text-secondary" />
            </div>
            <h3 className="text-xl font-bold mb-4 text-gray-800">Community Partnerships</h3>
            <p className="text-gray-700">
              We are building relationships with local organizations that already serve low income families, so they can identify who needs care and distribute vouchers directly.
            </p>
          </div>
          <div className="card p-8 text-center">
            <div className="w-16 h-16 bg-tertiary bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-6">
              <FeatherIcon name="home" className="text-tertiary" />
            </div>
            <h3 className="text-xl font-bold mb-4 text-gray-800">Shelter Support</h3>
            <p className="text-gray-700">
              We reduce the burden on local shelters by preventing pet overpopulation at the source through accessible spay and neuter services for underserved communities.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;